/* post-t7-1, Bloque I1 (#562): EL ORDEN DE LOS IDIOMAS EN "ESCOGE EL IDIOMA DEL VIDEO".

   ARCHIVO EN ASCII A PROPOSITO. Una sola funcion pura para las dos ventanas (la del alumno en el Panel y la del profe
   en el banco): primero Ingles, despues Espanol, despues Frances (cada uno solo si el video lo trae) y los demas en
   el orden en que llegan. Un idioma con variante cuenta como su idioma (`en-US`, `es-419`, `fr-CA`): el codigo
   empieza con `en`, `es` o `fr` y lo que sigue, si algo, no es otra letra (asi `est` o `eng` no cuentan como `es` o
   `en`). Varias variantes del mismo conservan entre si su orden de llegada. No quita ni agrega codigos. */
const PRIMEROS = ['en', 'es', 'fr'];

function grupoDe(codigo) {
  const c = String(codigo || '').toLowerCase();
  const i = PRIMEROS.findIndex((p) => c.startsWith(p) && !/[a-z]/.test(c.charAt(p.length)));
  return i === -1 ? PRIMEROS.length : i;
}

export function ordenarIdiomas(codigos) {
  return (codigos || [])
    .map((codigo, llegada) => ({ codigo, llegada, grupo: grupoDe(codigo) }))
    .sort((a, b) => (a.grupo - b.grupo) || (a.llegada - b.llegada))
    .map((x) => x.codigo);
}
